import { Link, useLocation, useNavigate } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";

interface NavbarDesktopProps {
  textColorClass: string;
  hoverColorClass: string;
}

export function NavbarDesktop({ textColorClass, hoverColorClass }: NavbarDesktopProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToPlanos = () => {
    const hasPlansSection = ['/', '/boleto-parcelado', '/antecipacao'].includes(location.pathname);
    
    if (!hasPlansSection) {
      navigate('/');
      setTimeout(() => {
        const planosSection = document.getElementById('planos');
        if (planosSection) {
          planosSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const planosSection = document.getElementById('planos');
      if (planosSection) {
        planosSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const navLinkClasses = `font-medium text-base ${textColorClass} ${hoverColorClass} transition-colors duration-200`;

  return (
    <nav className="hidden md:flex items-center gap-8">
      <Link
        to="/"
        className={navLinkClasses}
      >
        Home
      </Link>
      <NavigationMenu>
        <NavigationMenuList>
          <NavigationMenuItem>
            <NavigationMenuTrigger 
              className={`${navLinkClasses} !bg-transparent data-[state=open]:!bg-transparent`}
            >
              <span>Serviços</span>
            </NavigationMenuTrigger>
            <NavigationMenuContent className="min-w-[220px] z-50">
              <div className="bg-white p-3 rounded-lg shadow-md border border-gray-100">
                <Link
                  to="/boleto-parcelado"
                  className="block px-4 py-2.5 text-drcash-maastricht-blue hover:text-drcash-caribbean-green rounded-md transition-colors duration-200"
                >
                  Boleto parcelado
                </Link>
                <Link
                  to="/antecipacao"
                  className="block px-4 py-2.5 text-drcash-maastricht-blue hover:text-drcash-caribbean-green rounded-md transition-colors duration-200"
                >
                  Antecipação de cartão de crédito
                </Link>
              </div>
            </NavigationMenuContent>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>
      <Link
        to="/atendimento"
        className={navLinkClasses}
      >
        Atendimento
      </Link>
      <button
        onClick={scrollToPlanos}
        className={navLinkClasses}
      >
        Preços
      </button>
      <Link
        to="/acesse-portais"
        className="btn-primary text-sm font-medium px-6 py-2.5"
      >
        Acesso Clínicas
      </Link>
    </nav>
  );
}
